import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../baseQuery';

export interface ParentSlot {
	id: string;
	class: { classNumber: string; section: string };
	periodTemplate: {
		name: string;
		periodNumber: number;
		startTime: string;
		endTime: string;
	} | null;
	dayOfWeek: number;
	dayBucket: string;
	startsAt: string;
	endsAt: string;
	status: 'scheduled' | 'completed' | 'missed';
}

export const parentTimetableApi = createApi({
	reducerPath: 'parentTimetableApi',
	baseQuery: axiosBaseQuery,
	tagTypes: ['ParentWeek'],
	endpoints: (builder) => ({
		getChildWeek: builder.query<
			{
				weekStartDate?: string;
				startDate?: string;
				endDate?: string;
				timezone: string;
				slots: ParentSlot[];
			},
			{
				childId: string;
				weekStartDate?: string;
				startDate?: string;
				endDate?: string;
			}
		>({
			query: ({ childId, weekStartDate, startDate, endDate }) => ({
				url: '/parent/timetable/week',
				params: { childId, weekStartDate, startDate, endDate },
			}),
			providesTags: ['ParentWeek'],
		}),
	}),
});

export const { useGetChildWeekQuery } = parentTimetableApi;
